import React from "react";
import { RemoveSupplyProvider } from "src/context/RemoveSupplyFormContext";
import { RemoveSupplyDetail } from "../remove-supply";

export const DraftRemoveSupply: React.FC = () => {
  return (
    <RemoveSupplyProvider>
      <RemoveSupplyDetail data-id="draftRemoveSupplyDetail" />
    </RemoveSupplyProvider>
  );
};
